/* eslint-disable nonblock-statement-body-position */
/* eslint-disable curly */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./selection-range.scss";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Slider } from "@mui/material";

const SelectionRange = ({
  label,
  labelPosition,
  min,
  max,
  possibleMin,
  possibleMax,
  currentMin,
  currentMax,
  step,
  unit,
  onChange,
  setNoFilter,
  width,
  // changeWithInit,
  required,
  minimumLocked,
  maxSmallestValue
}) => {
  /*
    min and max are the ranges of the slider
    possibleMin and possibleMax are the ranges of the possible values
    (currentMin and currentMax should be between possibleMin and possibleMax or at least include one of them to be valid)
    this means that if currentMin < possibleMin, then currentMax should be >= possibleMin
    and if currentMax > possibleMax, then currentMin <= possibleMax
  */
  /*
  minValue :
  if currentMin in not defined, minValue is set to possibleMin
  if currentMin is defined :
  if currentMin < min, minValue is set to min
  if currentMin < possibleMin and currentMax >= possibleMin, minValue is set to currentMin
  if currentMin >= possibleMin and <= possibleMax, minValue is set to currentMin
  If currentMin > possibleMax, minValue is set to possibleMax.
  */
  /*
maxValue:
If currentMax is not defined, maxValue is set to possibleMax.
If currentMax is defined:
- If currentMax is greater than max, maxValue is set to max.
- If currentMax is greater than possibleMax and currentMin is less than or equal to possibleMax, maxValue is set to currentMax.
- If currentMax is less than or equal to possibleMax and greater than or equal to possibleMin, maxValue is set to currentMax.
- If currentMax is less than possibleMin, maxValue is set to possibleMin.
*/
  const [minValue, setMinValue] = useState(() => {
    if (currentMin !== undefined) {
      return currentMin;
    }
    return min;
  });

  const [maxValue, setMaxValue] = useState(() => {
    if (currentMax !== undefined) {
      return currentMax;
    }
    return max;
  });

  const calculateMin = (value) => {
    if (value < min) return min;
    if (value < possibleMin) return value;
    if (value >= possibleMin && value <= possibleMax) {
      if (maxValue >= possibleMax) return value;
      // return possibleMin;
    }
    if (value > possibleMax) return possibleMax;
    return value;
  };

  const calculateMax = (value) => {
    if (value > max) return max;
    if (value > possibleMax) return value;
    if (value >= possibleMin && value <= possibleMax) {
      if (minValue <= possibleMin) return value;
      // return possibleMax;
    }
    if (value < possibleMin) return possibleMin;
    return value;
  };

  function setMin(value) {
    const parsed = parseFloat(Number(value).toFixed(2));
    setMinValue(calculateMin(parsed));
  }
  function setMax(value) {
    // const parsed = parseInt(ev.target.value, 10);
    const parsed = parseFloat(Number(value).toFixed(2));
    if (parsed >= minValue) {
      if (maxSmallestValue && parsed < maxSmallestValue) {
        setMaxValue(maxSmallestValue);
      } else {
        setMaxValue(calculateMax(parsed));
      }
    }
  }

  function sendChanges() {
    console.log("sendChanges", minValue, maxValue, possibleMin, possibleMax);
    if (minValue >= possibleMin || maxValue <= possibleMax) {
      onChange(minValue, maxValue);
    } else {
      if (minValue < possibleMin) setMinValue(possibleMin);
      setNoFilter();
    }
  }

  useEffect(() => {
    if (minValue === undefined) {
      setMinValue(min);
    }
    if (maxValue === undefined) {
      setMaxValue(max);
    }
  }, [minValue, min, maxValue, max]);

  useEffect(() => {
    setMinValue(calculateMin(currentMin));
    setMaxValue(calculateMax(currentMax));
  }, [currentMin, currentMax]);

  return (
    <div className={`label-and-range${labelPosition === "top" ? " top" : ""}`} onMouseUp={sendChanges}>
      <div className="flex space-x-1 mb-1">
        <span className="flex space-x-1">
          <span className="">{label}</span>
        </span>

        {required && <span className="text-red-600">*</span>}
        {unit && <span className="text-gray-300 ">({unit})</span>}
      </div>
      {/* <div className="flex flex-col">
        <span>min = {min}</span>
        <span>possibleMin = {possibleMin}</span>
        <span>minValue = {minValue}</span>
        <span>maxValue = {maxValue}</span>
        <span>possibleMax = {possibleMax}</span>
        <span>max = {max}</span>
      </div> */}
      <div
        className="selection-range-layout px-2"
        style={{
          "--a": minValue,
          "--b": maxValue,
          "--max": max,
          "--min": min,
          "--possible-min": possibleMin,
          "--possible-max": possibleMax,
          "--width": width
        }}
      >
        <Slider
          value={[minValue, maxValue]}
          min={min}
          max={max}
          step={step}
          valueLabelDisplay="on"
          valueLabelFormat={(value) => `${value}`}
          disableSwap
          marks={[
            {
              value: min,
              label: min
            },
            {
              value: max,
              label: max
            }
          ]}
          sx={{
            color: "#626469",
            "& .MuiSlider-thumb": {
              height: 17,
              width: 17,
              backgroundColor: "#fff",
              border: "1px solid currentColor",
              "&:hover": {
                boxShadow: "0 0 0 8px rgba(58, 133, 137, 0.16)"
              }
            },
            "& .MuiSlider-track": {
              height: 5
            },
            "& .MuiSlider-rail": {
              color: "#d8d8d8",
              opacity: 1,
              height: 5
            },
            // cutomize the mark label
            "& .MuiSlider-markLabel": {
              fontSize: 12
            },
            // customize the valueLbael
            "& .MuiSlider-valueLabel": {
              fontSize: 12,
              borderRadius: 4,
              backgroundColor: "#d8d8d8",
              color: "#626469"
            }
          }}
          onChange={(event, newValues) => {
            console.log("Slider-onChange", newValues);
            if (!minimumLocked) {
              setMin(newValues[0]);
            }
            setMax(newValues[1]);
          }}
          className="mt-7"
        />
        {/* <div className="wrapp flexxx items-center py-2 hidden">
          <input
            id="start"
            disabled={minimumLocked}
            type="range"
            min={possibleMin}
            step={step}
            value={minValue}
            max={possibleMax}
            onInput={(ev) => {
              setMin(ev);
            }}
          />
          <input
            id="end"
            type="range"
            min={possibleMin}
            step={step}
            value={maxValue}
            max={possibleMax}
            onInput={(ev) => {
              setMax(ev);
            }}
          />
        </div> */}
        {/* <div className="w-full relative text-white hidden">
          <output
            className={`bg-gray-500 border-gray-300 py-1 px-2 w-fit rounded-xl hover:z-10 hover:scale-105 transition-all duration-75 ${
              minValue === 0 ? "hidden" : "absolute"
            }`}
            style={{ left: `${((minValue - min) * 100) / (max - min)}%` }}
          >
            {minValue}
          </output>
          <output
            className={`bg-gray-500 border-gray-300 py-1 px-2 w-fit rounded-xl hover:z-10 hover:scale-105 transition-all duration-75 ${
              minValue === maxValue || maxValue === 0 ? "hidden" : "absolute"
            }`}
            style={{ right: `${((maxValue - max) * 100) / (min - max)}%` }}
          >
            {maxValue}
          </output>
        </div> */}
        {/* <div className="flexx justify-between hidden">
          <p>{min}</p>
          <p>{max}</p>
        </div> */}
      </div>
    </div>
  );
};

SelectionRange.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  possibleMin: PropTypes.number,
  possibleMax: PropTypes.number,
  currentMin: PropTypes.number,
  currentMax: PropTypes.number,
  unit: PropTypes.string,
  step: PropTypes.number,
  onChange: PropTypes.func,
  setNoFilter: PropTypes.func,
  width: PropTypes.string,
  label: PropTypes.node,
  labelPosition: PropTypes.oneOf(["top", "left", "none"]),
  // changeWithInit: PropTypes.bool,
  required: PropTypes.bool,
  minimumLocked: PropTypes.bool,
  maxSmallestValue: PropTypes.number
};

SelectionRange.defaultProps = {
  currentMin: undefined,
  currentMax: undefined,
  possibleMin: undefined,
  possibleMax: undefined,
  unit: "",
  step: 1,
  onChange: () => {},
  setNoFilter: () => {},
  width: "100%",
  label: "",
  labelPosition: "top",
  // changeWithInit: false,
  required: false,
  minimumLocked: false,
  maxSmallestValue: 0
};

export default SelectionRange;
